import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { loginUser } from "../../api/APIServices";
import { API_STATUS } from "../../constants";

const isSessionExpired = () => {
    const expiry = localStorage.getItem("sessionExpiry");
    if (!expiry) return true;

    return Date.now() > Number(expiry);
};

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        status: API_STATUS.IDEL,
        errorMsg: '',
        userInfo: isSessionExpired() ? {} : JSON.parse(localStorage.getItem('userInfo') || "{}"),
        isAuthenticated: !isSessionExpired() && localStorage.getItem('isLoggedIn') === "true",
        token: isSessionExpired() ? '' : localStorage.getItem('token') || '',
        locale: 'en'
    },
    reducers: {

        logoutUser(state, action) {
            state.status = API_STATUS.IDEL;
            state.isAuthenticated = false
            state.token = ''
            state.userInfo = {}
            localStorage.removeItem('token');
            localStorage.removeItem('isLoggedIn');
            localStorage.removeItem('userInfo');
            localStorage.removeItem('sessionExpiry');
        },

    },
    extraReducers: (builder) => {
        builder.addCase(loginUser.pending, (state, action) => {
            state.status = API_STATUS.PENDING;
        }),
            builder.addCase(loginUser.fulfilled, (state, action) => {

                if (action.payload?.authorization) {
                    const expiryTime = Date.now() + 10 * 60 * 1000; // 10 minutes
                    localStorage.setItem('isLoggedIn', true);
                    localStorage.setItem('token', action.payload?.authorization);
                    localStorage.setItem('userInfo', JSON.stringify(action.payload?.user));
                    localStorage.setItem("sessionExpiry", expiryTime);

                    state.isAuthenticated = true
                    state.status = API_STATUS.SUCCESS;
                    state.errorMsg = '';
                    state.token = action.payload?.authorization
                    state.userInfo = action.payload?.user
                } else {
                    state.status = API_STATUS.ERROR;
                    state.errorMsg = action.payload.error
                }

            }),
            builder.addCase(loginUser.rejected, (state, action) => {
                state.status = API_STATUS.ERROR;
                state.errorMsg = action.error
            })
    }
})


export const { logoutUser } = authSlice.actions
export default authSlice.reducer